import type { MouseEvent } from "react"

import { Button } from "@coval/ui"

/**
 * The first focusable element on every page: held above the viewport until
 * it takes keyboard focus, then shown over the top-left corner. Activating it moves focus to
 * the page's one `<main>` landmark, so keyboard users can bypass the
 * navigation that repeats on every page. Focus moves without changing the
 * URL hash, which the router would otherwise treat as a navigation.
 */
export function SkipToMainLink() {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    const main = document.querySelector("main")
    if (!main) {
      return
    }
    if (!main.hasAttribute("tabindex")) {
      main.setAttribute("tabindex", "-1")
    }
    main.focus()
  }

  return (
    <Button
      asChild
      variant="secondary"
      className="fixed left-4 top-4 z-[100] -translate-y-16 focus-visible:translate-y-0"
    >
      <a href="#main-content" onClick={handleClick}>
        Skip to main content
      </a>
    </Button>
  )
}
